import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": ".8",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  viewBox: "0 0 20 20"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "m16.67 4.473 1.12.374-1.12.373-.372 1.119-.373-1.12-1.119-.372 1.12-.373.372-1.119.373 1.12zM8.727 4.25 10.1 8.367l4.118 1.373-4.118 1.373-1.373 4.117-1.372-4.117L3.237 9.74l4.118-1.373zM17.79 15.564l-1.12-.374-.373-1.119-.373 1.12-1.119.373 1.12.373.372 1.119.373-1.12z" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render: render }